<template>
  <div id="exchanges" style="height:100%;">
    <div class="box" :class="{ enRealTimeTransCC: isEnRealTimeTransCC }">
      <div class="maintrans">
        <!-- 限价交易 -->
        <!-- <ul v-show="limitTrue" class="content"> -->
        <ul class="content">
          <!-- 买入 -->
          <li v-show="buyOrSell == 'buy'" id="middleMargin" class="left" >
            <div class="transcc_new_NewFooter_left_top" :style="tradeViewStyle">
              <div class="transcc_new_NewFooter_left--left">
                <slot name="left"/>
                <ul class="price flex-price-box">
                  <li class="message">
                    <span
                      style="font-size:14px;color:#dfdfdf;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:10px;"
                    >买价</span>
                    <input
                      ref="pricesc"
                      v-model="price"
                      step="0.01"
                      class="sty"
                      onmousewheel="return false;"
                      type="number"
                      @input="limitBuyPrice"
                      @keyup.enter="shortcuts_F2()"
                      @keydown="channelInputLimitPrice"
                    >
                    <span></span>
                    <span style="display:none">{{
                      Number(pricesc).toFixed(2)
                    }}</span>
                    <span
                      style="position:absolute;top:10px;right:20px;color:rgba(255, 255, 255, 0.4);"
                    >{{ units }}</span>
                    <div class="pricebtns">
                      <i
                        class="el-icon-caret-top pricebtn"
                        @click="pricebtnbClick('up')"
                      />
                      <i
                        class="el-icon-caret-bottom pricebtn"
                        @click="pricebtnbClick('down')"
                      />
                    </div>
                  </li>
                  <li class="message"   style="margin-bottom:0;">
                    <span
                      style="font-size:14px;color:#dfdfdf;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:10px;"
                    >买量</span>
                    <input
                      ref="numc"
                      v-model="num"
                      step="0.01"
                      class="sty"
                      onmousewheel="return false;"
                      type="number"
                      @input="limitBuyNumber"
                      @keyup.enter="transBuybefore()"
                      @keydown="channelInputLimitNum"
                    >
                    <div class="numbtns">
                      <i
                        class="el-icon-caret-top numbtn"
                        @click="numbuyClick('up')"
                      />
                      <i
                        class="el-icon-caret-bottom numbtn"
                        @click="numbuyClick('down')"
                      />
                    </div>
                    <!-- <span style="position:absolute;top:10px;right:20px;color:rgba(255, 255, 255, 0.4);">{{ unit }}</span> -->
                  </li>
                </ul>
              </div>
              <div class="transcc_new_NewFooter_left--right">
                <slot name="right"></slot>
              </div>
            </div>
             <div class="transcc_new_NewFooter_left_bottom">
                  <div class="message topSelectChange buyBgc">
              <el-radio-group v-model="selectTop">
                <el-radio :label="0">销售①</el-radio>
                <el-radio :label="1">销售②</el-radio>
                <el-radio :label="2">销售③</el-radio>
              </el-radio-group>
            </div>
            <div class="buyStep">
              <el-slider
                :marks="marks"
                v-model="value1"
                show-stops=""
                :format-tooltip="formatTooltip"
                :disabled="disable"
                :step="20"
                @change="buyAmountset"
              >
              </el-slider>
            </div>
            <ul class="sum">
              <li class="message">
                <span class="priceText">可转让最大数量：</span>
                <span class="priceNum">{{ canBuy }} {{ units }}</span>
              </li>
            </ul>
            <div v-if="sessionInfoGetter.isLogin == 'true'">
              <input
                type="button"
                class="btn"
                :value="isXJ?'买入转让/托管':'买入转让'"
                :disabled="yesNo"
                @click="transBuy()"
              >
            </div>
            <div class="cotract">
              <el-checkbox v-model="isCheckHt"> </el-checkbox>&nbsp;我已同意签署<span @click="aggreementShow(1)" style=" cursor: pointer;">《订单商品销售协议》</span><span v-if="isAgreeInfo">和<span @click="aggreementShow(3)">《托管协议》</span></span>
            </div>
             </div>
          </li>
          <!-- 卖出 -->
          <li v-show="buyOrSell == 'sell'" class="left">
            <div class="transcc_new_NewFooter_left_top" :style="tradeViewStyle">
              <div class="transcc_new_NewFooter_left--left">
                <slot name="left"/>
                <ul class="price flex-price-box">
            <li class="message">
              <span
                style="font-size:14px;color:#dfdfdf;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:10px;"
              >卖价</span>
              <input
                ref="sellpricec"
                v-model="sell"
                step="0.01"
                class="sty"
                type="number"
                onmousewheel="return false;"
                @input="limitSellPrice"
                @keyup.enter="shortcuts_F4()"
                @keydown="channelInputLimitPrice"
              >
              <span style="display:none">{{ sells }}</span>
              <span
                style="position:absolute;top:10px;right:20px;color:rgba(255, 255, 255, 0.4);"
              >{{ units }}</span>
              <div class="pricebtns">
                <i
                  class="el-icon-caret-top pricebtn"
                  @click="pricebtnClick('up')"
                />
                <i
                  class="el-icon-caret-bottom pricebtn"
                  @click="pricebtnClick('down')"
                />
              </div>
            </li>
            <li class="message"   style="margin-bottom:0;">
              <span
                style="font-size:14px;color:#dfdfdf;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:10px;"
              >卖量</span>
              <input
                ref="sellnumc"
                v-model="number"
                step="0.01"
                class="sty"
                type="number"
                onmousewheel="return false;"
                @input="limitSellNumber"
                @keyup.enter="transSellbefore()"
                @keydown="channelInputLimitNum"
              >
              <div class="numbtns">
                <i
                  class="el-icon-caret-top numbtn"
                  @click="numsellClick('up')"
                />
                <i
                  class="el-icon-caret-bottom numbtn"
                  @click="numsellClick('down')"
                />
              </div>
              <!-- <span style="position:absolute;top:10px;right:20px;color:rgba(255, 255, 255, 0.4);">{{ unit }}</span> -->
            </li>
                </ul>
              </div>
              <div class="transcc_new_NewFooter_left--right">
                <slot name="right"></slot>
              </div>
            </div>
            <div class="transcc_new_NewFooter_left_bottom">
                          <div class="message topSelectChange sellBgc">
              <el-radio-group v-model="selectTop">
                <el-radio :label="0">采购①</el-radio>
                <el-radio :label="1">采购②</el-radio>
                <el-radio :label="2">采购③</el-radio>
              </el-radio-group>
            </div>
            <div class="tradStep">
              <el-slider
                v-model="value2"
                show-stops
                :format-tooltip="formatTooltip"
                :step="20"
                :marks="marks"
                @change="sellAmountset"
              >
              </el-slider>
            </div>
            <ul class="sum">
              <li class="message">
                <span class="priceText">可转让最大数量：</span>
                <span class="priceNum">{{ canSell }} {{ units }}</span>
              </li>
            </ul>
            <div v-if="sessionInfoGetter.isLogin == 'true'">
              <input
                type="button"
                class="btn"
                :value="isXJ?'卖出转让/托管':'卖出转让'"
                :disabled="yesNo2"
                onkeyup="this.value=this.value.replace(/^\d+\.?\d{0,2}$/)"
                @click="transSell()"
              >
            </div>
            <!-- 《商品订单、转让合同》 -->
            <div class="cotract">
              <el-checkbox v-model="isCheckHt"> </el-checkbox>&nbsp;我已同意签署<span @click="aggreementShow(2)" style=" cursor: pointer;">《订单商品销售协议》</span><span v-if="isAgreeInfo">和<span @click="aggreementShow(4)">《托管协议》</span></span>
            </div>
            </div>

          </li>
        </ul>
      </div>
    </div>
    <span style="display:none">{{ data }}</span>

    <!-- dialog 快捷平仓 -->
    <el-dialog
      style="overflow-y: auto;"
      title="快捷撤单"
      :visible.sync="dialogDiscover"
      class="stop-profit-loss"
    >
      <el-row class="zr_dialog_input">
        <el-col :span="6"><div style="line-height:40px">最低价格</div></el-col>
        <el-col :span="18">
          <el-input
            ref="dialog_lowPrice"
            v-model="transfer.lowPrice"
            type="number"
            placeholder="最低价格"
            @keyup.enter.native="lowPriceEnter"
          ></el-input>
        </el-col>
      </el-row>
      <el-row class="zr_dialog_input">
        <el-col :span="6"><div style="line-height:40px">最高价格</div></el-col>
        <el-col :span="18">
          <el-input
            ref="dialog_highPrice"
            v-model="transfer.highPrice"
            type="number"
            :disabled="disablePC"
            placeholder="最高价格"
            @keyup.enter.native="tackAndLossConfirm"
          ></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button class="el-cancel-btn" @click="dialogDiscover = false">取消</el-button>
        <el-button
          type="primary"
          class="el-confirm-btn"
          :disabled="disablePC"
          @click="tackAndLossConfirm"
        >确定</el-button>
      </div>
    </el-dialog>
    <!-- dialog 买卖合同 -->
    <el-dialog
      id="gsHt"
      title="合同"
      :visible.sync="dialogDiscoverHt"
      :before-close="handleClose1"
    >
      <el-row class="zr_dialog_input">
        <el-col :span="22">
          <HtMessage
            :bs-flag="htBsflag"
            :price="htPrice"
            :amount="htAmount"
            :transaction-volume="htTransactionVolume"
          ></HtMessage>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button class="el-cancel-btn" @click="dialogDiscoverHt = false">我不能接受</el-button> -->
        <el-button
          id="btns"
          type="primary"
          class="el-confirm-btn"
          :disabled="disableHt"
          @click="htSuccess"
        >{{ btnText }}</el-button>
      </div>
    </el-dialog>
    <!-- 是否查看风险协议弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      style="height: 45%"
      :before-close="handleClose"
    >
      <div v-if="!agreementFlag" class="protol_top">
        <div class="pt_title">是否查看协议</div>
        <div class="dialog_footer">
          <el-button @click="cancelClick">取 消</el-button>
          <el-button type="primary" @click="enterClick">确 定</el-button>
        </div>
      </div>
      <div v-else class="protol_bottom">
        <div class="pb_title">加载中...</div>
        <el-progress :percentage="percentageNum" :format="format"></el-progress>
      </div>
    </el-dialog>
    <confirmDialog
      ref="confirmDialog"
      title="是否查看协议"
      @reLoad="confirmAggreement"
    />
    <confirmDialog
      ref="transBuyDialog"
      title="是否确认买入转让"
      @reLoad="transBuyControl"
    />
    <confirmDialog
      ref="transSellDialog"
      title="是否确认卖出转让"
      @reLoad="transSellControl"
    />
    <hint-dialog ref="hintDialog" @reLoad="confirmHint" />
    <aggreement-dialog ref="aggreementDialog" @reLoad="aggreementOk" />
    <tgAgreementDialog ref="tgAgreementDialog" @reLoad="aggreementOk" />
  </div>
</template>
<script>
/* global hqProtocol hqWs protocol http */
import { mapGetters } from 'vuex'
import HtMessage from './HtMessage'
import confirmDialog from '../../../components/base/dialog/confirmDialog.vue'
import HintDialog from '../../../components/base/dialog/hintDialog.vue'
import aggreementDialog from '../../../components/base/dialog/aggreementDialog.vue'
import tgAgreementDialog from '../../../components/base/dialog/tgAgreementDialog.vue'
export default {
  name: 'RealTimeTransCC',
  components: {
    HtMessage,
    confirmDialog,
    HintDialog,
    aggreementDialog,
    tgAgreementDialog
  },
  props: {
    buyOrSell: {
      type: String,
      default: ''
    },
    selectTradeType: {
      type: String,
      default: ''
    }
  },
  inject: ['tradeView'],
  data() {
    return {
      marks:{
        0:'0%',
        20:'20%',
        40:'40%',
        60:'60%',
        80:'80%',
        100:'100%'
      },
      isAgreeInfo: window.g.isSupInfo,
      isBuy: 1,
      formData: {},
      selectTop: 0,
      isCheckHt: true, // 是否签署合同
      timeInterval: null,
      timeText: null,
      btnText: '',
      btnFlag: 1, // 1 买入开多 2 卖出开空
      setIntervalTime: null,
      percentageNum: 0,
      agreementFlag: false,
      dialogVisible: false,
      passwordShow1: false,
      radio: 0,
      isChangedDisable: false,
      priceTrue: false,
      limitTrue: true,
      TotalMoney: '21.0000003',
      message: '费率',
      isTrue: true,
      isTrueA: false,
      num: '',
      number: '',
      yesNo: false,
      yesNo2: false,
      sell: ' ',
      price: '',
      balance1: null,
      balance2: null,
      isEnRealTimeTransCC: false,
      lt1: '',
      lt2: '',
      value1: [0, 10],
      value2: 0,
      disable: false,
      selectGood: false,
      goodName: '',
      goodMemo: '',
      addrCopy: '',
      addr: '',
      dialogChargeVisible: false,
      currentChargeCoin: '',
      dialogDiscover: false,
      transfer: {
        highPrice: '',
        lowPrice: ''
      },
      disablePC: false,
      timer: null,
      selectHoldFront: [
        {
          avgPrice: 0,
          bsFlag: 'B',
          commodityCode: '',
          commodityId: 0,
          commodityName: '',
          createTime: 0,
          firmId: 0,
          holdId: 0,
          holdMargin: 0,
          quantity: 0,
          totalPrice: 0,
          tqTransferQuantity: '--', // 可现货买进转让数量
          transferQuantity: '--', // 可转让数量
          unitNumeral: 0,
          updateTime: 0,
          frozeQuantity: 0,
          optimizeQuantity: 0
        },
        {
          avgPrice: 0,
          bsFlag: 'S',
          commodityCode: '',
          commodityId: 0,
          commodityName: '',
          createTime: 0,
          firmId: 0,
          holdId: 0,
          holdMargin: 0,
          quantity: 0,
          totalPrice: 0,
          tqTransferQuantity: '--', // 可现货买进转让数量
          transferQuantity: '--', // 可转让数量
          unitNumeral: 0,
          updateTime: 0,
          dQuantity: 0,
          frozeQuantity: 0,
          optimizeQuantity: 0
        }
      ],
      // 合同
      dialogDiscoverHt: false,
      disableHt: false,
      Htjs: null,
      htBsflag: '',
      htPrice: '',
      htAmount: '',
      htTransactionVolume: '--',
      // 数量随top变动限制
      numBuylock: false,
      numSelllock: false,
      ordersDialog: false,
      isXJ: window.g.APP_WINNY_NAME === '硒交在线'
    }
  },
  computed: {
    ...mapGetters([
      'h_holdTime',
      'sessionInfoGetter',
      'item',
      'myassetDataGetter',
      'commodityStrategyGetter',
      'h_tradeTime',
      'h_avilibleMargin',
      'isChangeMarginPsdGetter',
      'userPositionSummariesGetter',
      'verticalityclick',
      'verticalityclick_up',
      'verticalityclick_down'
    ]),
    data() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return item
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    selectCommodityStrategy() {
      if (this.data !== '--' && this.commodityStrategyGetter.length > 0) {
        for (const CommodityStrategy of this.commodityStrategyGetter) {
          if (this.data == CommodityStrategy.commodityId) {
            return CommodityStrategy
          }
        }
      } else if (this.data == '--' && this.commodityStrategyGetter.length > 0) {
        return this.commodityStrategyGetter[0]
      }
      return {
        canBuy: '0',
        canDqDelivery: '--',
        canSell: '0',
        canShow: '--',
        canTqDelivery: '--',
        canTqTransfer: '--',
        canTransfer: '--',
        commodityCode: '--',
        commodityId: null,
        commodityName: '--',
        feeStrategyId: '--',
        guidePrice: '--',
        holdStrategyId: '--',
        margin: '--',
        marginStrategyId: '--',
        marginType: '--',
        marketPrice: '--',
        maxHoldAmount: '--',
        maxSingleTradeAmount: '--',
        maxUpDownWidth: '--',
        minAmountChange: 0.01,
        minPickupAmount: '--',
        minPriceChange: 0.01,
        minSingleTradeAmount: '--',
        offerEndTime: 0,
        openFee: '--',
        openFeeType: '--',
        pickupCountdown: '--',
        pickupStandard: '--',
        pickupStartTime: 0,
        tradeStrategyId: '--',
        transferFee: '--',
        transferFeeType: '--',
        unitNumeral: '--',
        unitQuantifier: '--',
        sellMargin: '--',
        sellMarginType: '--'
      }
    },
    unit() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[0]
        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[0]
        } else {
          return ''
        }
      }
    },
    units() {
      const item = this.$store.state.hqData.item.symbol
      if (item) {
        const strDian = item.split('/')
        const strDianQian = strDian[1]
        return strDianQian
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbol.split('/')[1]
        } else {
          return ''
        }
      }
    },
    sells() {
      const item = this.$store.state.hqData.item.close
      if (item) {
        return Number(item).toFixed(this.item.coinDigitalNum)
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return Number(
            this.$store.state.hqData.marketDetails[0].close
          ).toFixed(this.item.coinDigitalNum)
        } else {
          return '--'
        }
      }
    },
    pricesc() {
      const item = this.$store.state.hqData.item.close
      if (item) {
        return Number(item).toFixed(this.item.coinDigitalNum)
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].close
        } else {
          return '--'
        }
      }
    },
    buyLst() {
      const item = this.$store.state.hqData.buyLst
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    sellLst() {
      const item = this.$store.state.hqData.sellLst
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    sellOne() {
      const item = this.$store.state.hqData.sellOne
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    buyOne() {
      const item = this.$store.state.hqData.buyOne
      if (item) {
        return item
      } else {
        return '--'
      }
    },
    canBuy() {
      // let num
      // if (this.price > 0) {
      //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //   this.lt1 = '<'
      //   num = this.balance1 / (this.price * this.selectCommodityStrategy.unitNumeral)
      // } else {
      //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //   this.lt1 = ' '
      //   num = '--'
      // }
      // return num
      for (let i = 0; i < this.selectHoldFront.length; i++) {
        const element = this.selectHoldFront[i]
        if (element.bsFlag == 'S') {
          return Number(element.quantity - element.frozeQuantity - element.optimizeQuantity).toFixed(
            this.item.quantityNum
          )
        }
      }
      return '0'
    },
    canSell() {
      // let num
      // if (this.sell > 0) {
      //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //   this.lt2 = '<'
      //   num = this.balance2 / (this.sell * this.selectCommodityStrategy.unitNumeral)
      // } else {
      //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //   this.lt2 = ' '
      //   num = '--'
      // }
      // return num
      for (let i = 0; i < this.selectHoldFront.length; i++) {
        const element = this.selectHoldFront[i]
        if (element.bsFlag == 'B') {
          return Number(element.quantity - element.frozeQuantity - element.optimizeQuantity).toFixed(
            this.item.quantityNum
          )
        }
      }
      return '0'
    },
    // 资产小数点位数(合约)
    coinDigitalNum() {
      return 2
    },
    tradeViewStyle() {
      if(!this.tradeView()){
        return {
          'flex-direction':'row-reverse'
        }
      }else{
        return 
      }
    },
    tradeViewMargin(){
      if(!this.tradeView()){
        return {
        'margin-left': 0,
        'margin-right': 9+'px'
      }
      }
    }
  },
  watch: {
    buyOrSell() {
      this.selectTop = 0
      if (this.buyOrSell === 'buy') {
        localStorage.setItem('commFormPrice', this.price)
        localStorage.setItem('commFormNum', this.num)
      } else {
        localStorage.setItem('commFormPrice', this.sell)
        localStorage.setItem('commFormNum', this.number)
      }
    },
    selectTop() {
      // 切换top选中,解锁数量.价格随top变化限制
      this.emitChangeTypeUnlock()
      setTimeout(() => {
        this.initPrice()
      }, 0)
    },
    data(val, oldVal) {
      if (val && this.data != '--') {
        this.queryUserPositionSummariesNew()
      }
    },
    item: function(xin, jiu) {
      if (xin.symbolId !== jiu.symbolId) {
        const _this = this
        this.numBuylock = false
        this.numSelllock = false
        setTimeout(() => {
          this.selectTop = 0
          _this.initPrice()
        }, 500)
      }
    },
    // unit: function() {
    //   if (this.sessionInfoGetter.isLogin == 'true') {
    //     this.creditAvailable()
    //   }
    // },
    // units: function() {
    //   if (this.sessionInfoGetter.isLogin == 'true') {
    //     this.creditAvailable()
    //   }
    // },
    // price(val){
    //   if(!val) return
    //     if(!/^\d*\.?\d{0,2}$/.test(val)){
    //     }
    // }
    buyOne: function(val, oldVal) {
      if (val[0] != '--' && this.selectTradeType == '1') {
        this.emitChangeTypeLock()
        this.sell = Number(val[0]).toFixed(this.item.coinDigitalNum)
      } else {
        this.sell = ''
      }
    },
    sellOne: function(val, oldVal) {
      if (val[0] != '--' && this.selectTradeType == '1') {
        this.emitChangeTypeLock()
        this.price = Number(val[0]).toFixed(
          this.item.coinDigitalNum
        )
      } else {
        this.price = ''
      }
    },
    buyLst() {
      if (window.g.APP_ISAUTOPRICE && this.selectTradeType === '1') {
        this.initPrice()
      }
    },
    sellLst() {
      if (window.g.APP_ISAUTOPRICE && this.selectTradeType === '1') {
        this.initPrice()
      }
    },
    h_avilibleMargin(val, oldVal) {
      if (val) {
        this.balance1 = val
        this.balance2 = val
      }
    },
    // 最新成交id
    h_tradeTime(val, oldVal) {
      this.queryUserPositionSummariesNew()
    },
    h_holdTime() {
      this.queryUserPositionSummariesNew() // 查询持仓汇总
    },
    userPositionSummariesGetter() {
      this.selectHoldFront = this.synchronizationSummerData(
        this.selectHoldFront
      )
    },
    dialogDiscoverHt(val, oldVal) {
      if (!val) {
        this.yesNo = false
        this.yesNo2 = false
      }
    },
    verticalityclick() {
      this.shortcuts_verticality()
    },
    verticalityclick_up() {
      this.shortcuts_verticality_up() // 微调价格和数量
    },
    verticalityclick_down() {
      this.shortcuts_verticality_down() // 微调价格和数量
    },
    price(val) {
      if (this.buyOrSell === 'buy') {
        localStorage.setItem('commFormPrice', val)
      }
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },
    sell(val) {
      if (this.buyOrSell === 'sell') {
        localStorage.setItem('commFormPrice', val)
      }
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },
    num(val) {
      if (this.buyOrSell === 'buy') {
        localStorage.setItem('commFormNum', this.num)
      }
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },
    number(val) {
      if (this.buyOrSell === 'sell') {
        localStorage.setItem('commFormNum', this.number)
      }
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    }
  },
  created: function() {
    // this.sell = buyLst[0].amount;
    // this.price = buyLst[0].amount;
    if (this.sessionInfoGetter.isLogin == 'true') {
      // this.currency();
      this.creditAvailable()
    }
    setTimeout(
      () => {
        hqProtocol.param_top.symbol = this.data // this.$store.state.hqData.marketDetails[0].symbolId
        hqWs.send(hqProtocol.param_top)
      },
      window.g.TOP_REFRESH_TIME ? window.g.TOP_REFRESH_TIME : 1000
    )
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  mounted: function() {
    const _this = this
    setTimeout(() => {
      _this.initPrice()
    }, 1000)
    // 禁止input滚轮(兼容火狐)
    function MouseWheel(event) {
      event = event || window.event
      event.preventDefault()
    }
    const aInp = document.getElementsByTagName('input')
    for (let i = 0; i < aInp.length; i++) {
      aInp[i].addEventListener('DOMMouseScroll', MouseWheel, false)
    }
    this.queryUserPositionSummariesNew()
  },
  methods: {
    aggreementOk() {
      this.isCheckHt = true
    },
    // 展示协议 --- 带数据过去，最终协议要显示
    aggreementShow(type) {
      this.isBuy = type
      this.$refs.confirmDialog.showDialog()
    },
    // 进度条
    confirmAggreement() {
      this.$refs.hintDialog.showDialog()
    },
    // 协议文本弹框
    confirmHint() {
      if (this.isBuy === 3 || this.isBuy === 4) {
        this.$refs.tgAgreementDialog.showDialog()
      } else {
        this.$refs.aggreementDialog.showDialog(this.isBuy)
      }
    },
    // 卖价格+ -
    pricebtnClick(ty) {
      this.emitChangeTypeLock()
      if (this.sell || this.sell == 0) {
        if (ty === 'down') {
          this.sell = (
            Number(this.sell) -
            Number(this.selectCommodityStrategy.minPriceChange)
          ).toFixed(this.item.coinDigitalNum)
        } else {
          this.sell = (
            Number(this.sell) +
            Number(this.selectCommodityStrategy.minPriceChange)
          ).toFixed(this.item.coinDigitalNum)
        }
      }
      if (Number(this.sell) < 0) {
        this.sell = 0
      }
    },
    // 卖数量 + -
    numsellClick(ty) {
      this.numSelllock = true
      if (this.number || this.number == 0) {
        if (ty === 'down') {
          this.number = (
            Number(this.number) -
            Number(this.selectCommodityStrategy.minAmountChange)
          ).toFixed(this.item.quantityNum)
        } else {
          this.number = (
            Number(this.number) +
            Number(this.selectCommodityStrategy.minAmountChange)
          ).toFixed(this.item.quantityNum)
        }
      }
      if (Number(this.number) < 0) {
        this.number = 0
      }
    },
    // 买价格 + -
    pricebtnbClick(ty) {
      this.emitChangeTypeLock()
      if (this.price || this.price == 0) {
        if (ty === 'down') {
          this.price = (
            Number(this.price) -
            Number(this.selectCommodityStrategy.minPriceChange)
          ).toFixed(this.item.coinDigitalNum)
        } else {
          this.price = (
            Number(this.price) +
            Number(this.selectCommodityStrategy.minPriceChange)
          ).toFixed(this.item.coinDigitalNum)
        }
      }
      if (Number(this.price) < 0) {
        this.price = 0
      }
    },
    // 买数量 + -
    numbuyClick(ty) {
      this.numBuylock = true
      if (this.num || this.num == 0) {
        if (ty === 'down') {
          this.num = (
            Number(this.num) -
            Number(this.selectCommodityStrategy.minAmountChange)
          ).toFixed(this.item.quantityNum)
        } else {
          this.num = (
            Number(this.num) +
            Number(this.selectCommodityStrategy.minAmountChange)
          ).toFixed(this.item.quantityNum)
        }
      }
      if (Number(this.num) < 0) {
        this.num = 0
      }
    },
    // 修改某一项变更市价/限价
    emitChangeTypeLock() {
      this.$emit('emitChangeTypeLock')
    },
    // 解锁top价格/数量随动的限制
    emitChangeTypeUnlock() {
      this.$emit('emitChangeTypeUnlock')
    },
    btnTimeFun() {
      const that = this
      this.disableHt = true
      this.timeText = window.g.BTN_Time
      this.timeInterval = setInterval(() => {
        if (Number(that.timeText) <= 0) {
          that.btnText = '我已阅读并同意'
          that.disableHt = false
          clearInterval(that.timeInterval)
          return
        }
        that.timeText--
        that.btnText = '我已阅读并同意' + '(' + that.timeText + 's' + ')'
      }, 1000)
    },
    handleClose1() {
      this.dialogVisible = false
      this.dialogDiscoverHt = false
      this.percentageNum = 0
      clearInterval(this.setIntervalTime)
    },
    handleClose() {
      this.dialogVisible = false
      this.percentageNum = 0
      clearInterval(this.setIntervalTime)
    },
    format(percentage) {
      return percentage === 100 ? '100%' : `${percentage}%`
    },
    // 确定按钮
    enterClick() {
      const that = this
      this.percentageNum = 0
      this.agreementFlag = true
      var a = (window.g.scheduleTime / 100) * 1000
      this.setIntervalTime = setInterval(() => {
        that.percentageNum++
        if (that.percentageNum == 100) {
          that.dialogVisible = false
          that.btnTimeFun()
          clearInterval(that.setIntervalTime)
          if (that.btnFlag == 1) {
            that.transBuyControl()
          } else {
            that.transSellControl()
          }
        }
      }, a)
    },
    // 取消按钮
    cancelClick() {
      this.dialogVisible = false
      if (this.btnFlag == 1) {
        this.transBuyControl()
      } else {
        this.transSellControl()
      }
      this.htSuccess()
    },
    initPrice() {
      if (window.g.FAST_SET.FAST_AutoFill_price) {
        // 自动填充价格
        this.initPriceP()
      }
      if (window.g.FAST_SET.FAST_AutoFill_quantity) {
        // 自动填充数量
        this.initPriceM()
      }
    },
    // 拆分initPrice
    // 价格跟随top变动
    initPriceP() {
      let topn = 0
      topn = this.selectTop
      // top1价格
      if (this.sellLst.length > 0 && this.sellLst[topn][0] != '--') {
        this.price = Number(this.sellLst[topn][0]).toFixed(
          this.item.coinDigitalNum
        )
      } else {
        this.price = ''
      }
      if (
        this.buyLst.length > 0 &&
        this.buyLst[this.buyLst.length - 1 - topn][0] != '--'
      ) {
        this.sell = Number(
          this.buyLst[this.buyLst.length - 1 - topn][0]
        ).toFixed(this.item.coinDigitalNum)
      } else {
        this.sell = ''
      }
    },
    // 拆分initPrice
    // 数量跟随top变动 数量变化有单独的限制规则
    initPriceM() {
      let topn = 0
      topn = this.selectTop
      // 卖
      if (!this.numSelllock) {
        if (
          this.buyLst.length > 0 &&
          this.buyLst[this.buyLst.length - 1 - topn][2] != '--'
        ) {
          this.number = (
            Number(this.buyLst[this.buyLst.length - 1 - topn][2])
            // / this.selectCommodityStrategy.unitNumeral 2023 0804 去掉除以交易单
          ).toFixed(this.item.quantityNum)
        } else {
          this.number = ''
        }
      }
      // top1数量 买
      if (!this.numBuylock) {
        if (this.sellLst.length > 0 && this.sellLst[topn][2] != '--') {
          this.num = (
            Number(this.sellLst[topn][2])
            // / this.selectCommodityStrategy.unitNumeral 2023 0804 去掉除以交易单
          ).toFixed(this.item.quantityNum)
        } else {
          this.num = ''
        }
      }
    },
    changePasswordShow1() {
      if (this.passwordShow1 == 'password') {
        this.passwordShow1 = 'text'
      } else {
        this.passwordShow1 = 'password'
      }
    },
    changeType() {
      this.isBBToList = !this.isBBToList
    },
    inputMinChange(num, minChange) {
      // 空值检查
      if (num === '') return '';
      
      // 转换为数字
      const numValue = parseFloat(num);
      
      // 检查是否为有效数字
      if (isNaN(numValue)) {
        return '';
      }
      
      // 后台配置的小数位数
      const minDP = minChange.toString().split('.')[1]?.length ? minChange.toString().split('.')[1]?.length : 0;
      // 检查小数位数
      const decimalPart = num.toString().split('.')[1];
      if (decimalPart && decimalPart.length > minDP) {
        // 自动截断为2位小数
        return Math.floor(numValue * Math.pow(10, minDP)) / Math.pow(10, minDP)
      }
      return num
    },
    limitBuyPrice() {
      this.emitChangeTypeLock()
      // const numStr = this.item.numStr
      if (this.$refs.pricesc.value.length >= 1) {
        // this.$refs.pricesc.value = this.$refs.pricesc.value.replace(
        //   numStr,
        //   '$1.$2'
        // )
        // this.price = this.$refs.pricesc.value
        // this.$refs.pricesc.value = this.inputMinChange(this.price, this.item.minPriceChange)
        this.price = this.inputMinChange(this.price, this.item.minPriceChange)
      } else {
        this.$refs.pricesc.value = this.$refs.pricesc.value.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
        this.price = this.$refs.pricesc.value
      }
      // 同步合同字段
      this.htBsflag = 'B'
      this.htPrice = this.price
      this.htAmount = this.num
      this.htTransactionVolume = '--'
      // this.getAnalogueMobile('S', that.data, that.sell, that.num)
      localStorage.setItem('commFormPrice', this.price)
      localStorage.setItem('commFormNum', this.num)
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },
    limitBuyNumber() {
      // this.emitChangeTypeLock()
      this.numBuylock = true
      if (this.$refs.numc.value && this.$refs.numc.value.indexOf('-') > -1) {
        this.$refs.numc.value = ''
        this.number = ''
      }
      // const numStr = this.item.quantityStr
      // if (this.$refs.numc.value.length >= 2) {
      //   this.$refs.numc.value = this.$refs.numc.value.replace(numStr, '$1.$2')
      //   this.num = this.$refs.numc.value
      // } else {
      this.$refs.numc.value = this.$refs.numc.value.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
      this.num = this.$refs.numc.value
      // }
      // 同步合同字段
      this.htBsflag = 'B'
      this.htPrice = this.price
      this.htAmount = this.num
      this.htTransactionVolume = '--'
      // this.getAnalogueMobile('S', that.data, that.sell, that.num)
      localStorage.setItem('commFormPrice', this.price)
      localStorage.setItem('commFormNum', this.num)
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },
    channelInputLimitPrice(e) {
      const key = e.key
      // 不允许输入'e'
      // if (key === 'e' || key === 'E' || key === '.') {
      if (this.item.minPriceChange.toString().split('.')[1]?.length) {
        if (key === 'e' || key === 'E') {
          e.returnValue = false
          return false
        }
      } else {
        if (key === 'e' || key === 'E' || key === '.') {
          e.returnValue = false
          return false
        }
      }
      return true
    },
    channelInputLimitNum(e) {
      const key = e.key
      // 不允许输入'e'
      // if (key === 'e' || key === 'E' || key === '.') {
      if (this.item.minAmountChange.toString().split('.')[1]?.length) {
        if (key === 'e' || key === 'E') {
          e.returnValue = false
          return false
        }
      } else {
        if (key === 'e' || key === 'E' || key === '.') {
          e.returnValue = false
          return false
        }
      }
      return true
    },
    limitSellNumber() {
      // this.emitChangeTypeLock()
      this.numSelllock = true
      // const numStr = this.item.quantityStr
      // if (this.$refs.sellnumc.value.length >= 2) {
      //   this.$refs.sellnumc.value = this.$refs.sellnumc.value.replace(
      //     numStr,
      //     '$1.$2'
      //   )
      //   this.number = this.$refs.sellnumc.value
      // } else {
      this.$refs.sellnumc.value = this.$refs.sellnumc.value.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
      this.number = this.$refs.sellnumc.value
      // }
      // 同步合同字段
      this.htBsflag = 'S'
      this.htPrice = this.sell
      this.htAmount = this.number
      this.htTransactionVolume = '--'
      // this.getAnalogueMobile('S', that.data, that.sell, that.num)
      localStorage.setItem('commFormPrice', this.sell)
      localStorage.setItem('commFormNum', this.number)
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },
    limitSellPrice() {
      this.emitChangeTypeLock()
      // const numStr = this.item.numStr
      if (this.$refs.sellpricec.value.length >= 2) {
        // this.$refs.sellpricec.value = this.$refs.sellpricec.value.replace(
        //   numStr,
        //   '$1.$2'
        // )
        // this.sell = this.$refs.sellpricec.value
        // this.$refs.sellpricec.value = this.inputMinChange(this.sell, this.item.minPriceChange)
        this.sell = this.inputMinChange(this.sell, this.item.minPriceChange)
      } else {
        this.$refs.sellpricec.value = this.$refs.sellpricec.value.replace(/[^\d]/g, '').replace(/^0{1,}/g, '')
        this.sell = this.$refs.sellpricec.value
      }
      // 同步合同字段
      this.htBsflag = 'S'
      this.htPrice = this.sell
      this.htAmount = this.number
      this.htTransactionVolume = '--'
      // this.getAnalogueMobile('S', that.data, that.sell, that.num)
      localStorage.setItem('commFormPrice', this.sell)
      localStorage.setItem('commFormNum', this.number)
      localStorage.setItem('commFormDj', this.htTransactionVolume)
    },

    formatTooltip(val) {
      return val + '%'
    },
    // 卖数量改变
    sellAmountset(val) {
      this.emitChangeTypeLock()
      // // // let nums = global.util.floatDiv(this.balance2,this.sell)
      // // const nums = Number(this.balance2) / (1 + Number(this.coinSmallDigital.sellFeePercentage)) // 计算卖出手续费
      // // const current = val / 100
      // // const sliderNum = global.util.floatMul(nums, current)
      // // // this.number = Number(sliderNum).toFixed(this.coinSmallDigital.quantityNum)

      // // const num = Number(sliderNum)
      // // const precisionNum = Math.pow(10, this.coinSmallDigital.quantityNum)
      // // this.number = (Math.floor(num * precisionNum) / precisionNum).toFixed(this.coinSmallDigital.quantityNum)

      // let sellMargin = 0.01// 默认不取0
      // if (this.selectCommodityStrategy.sellMarginType == '1') {
      //   sellMargin = this.selectCommodityStrategy.sellMargin
      // } else {
      //   sellMargin = Number(this.price) * this.selectCommodityStrategy.sellMargin
      // }
      // let openFee = 0.01// 默认不取0
      // if (this.selectCommodityStrategy.openFeeType == '1') {
      //   openFee = this.selectCommodityStrategy.openFee
      // } else {
      //   openFee = Number(this.price) * this.selectCommodityStrategy.openFee
      // }
      const current = val / 100
      // const returnNum = global.util.floatMul((this.balance2 / (sellMargin + openFee)), current)
      // this.number = Number(Number(returnNum) / this.selectCommodityStrategy.unitNumeral).toFixed(0)
      if (Number(this.canSell) > 0) {
        const returnNum = global.util.floatMul(Number(this.canSell), current)
        this.number = Math.floor(Number(returnNum))
      } else {
        this.number = 0
      }
    },
    buyAmountset(val) {
      this.emitChangeTypeLock()
      // // this.balance1
      // // this.price
      // // 可买量
      // let margin = 0.01// 默认不取0
      // if (this.selectCommodityStrategy.marginType == '1') {
      //   margin = this.selectCommodityStrategy.margin
      // } else {
      //   margin = Number(this.price) * this.selectCommodityStrategy.margin
      // }
      // let openFee = 0.01// 默认不取0
      // if (this.selectCommodityStrategy.openFeeType == '1') {
      //   openFee = this.selectCommodityStrategy.openFee
      // } else {
      //   openFee = Number(this.price) * this.selectCommodityStrategy.openFee
      // }
      const current = val / 100
      // const returnNum = global.util.floatMul((this.balance1 / (margin + openFee)), current)
      // this.num = Number(Number(returnNum) / this.selectCommodityStrategy.unitNumeral).toFixed(0)
      if (Number(this.canBuy) > 0) {
        const returnNum = global.util.floatMul(Number(this.canBuy), current)
        this.num = Math.floor(Number(returnNum))
      } else {
        this.num = 0
      }
    },
    // 限价交易
    show: function() {
      this.isTrue = true
      this.isTrueA = false
      this.priceTrue = false
      this.limitTrue = true
    },
    setyesNoFalse() {
      const _this = this
      setTimeout(() => {
        _this.yesNo = false
      }, 0)
    },
    setyesNo2False() {
      const _this = this
      setTimeout(() => {
        _this.yesNo2 = false
      }, 0)
    },
    transSellbefore() {
      if (this.ordersDialog) {
        this.setOrdersDialog()
        return
      }
      this.transSell()
    },
    transSell: function() {
      this.btnFlag = 2
      // 配置是否有弹窗提示
      const showDialog = window.g.FAST_SET.FAST_show_Dialog
      if (showDialog) {
        // 陇南普通版 默认弹窗 2023 06 27
        this.$confirm('确认下单, 是否继续?', {
          customClass: 'blackMessage',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              const that = this
              instance.$refs['confirm'].$el.onclick = (function(e) {
                e = e || window.event
                if (e.detail === 0) {
                  that.ordersDialog = true
                }
              }())
            }
            done()
          }
        }).then(() => {
          this.transSellControl()
        }).catch(() => {
        })
      } else {
        this.transSellControl()
      }
    },
    transSellControl() {
      this.yesNo2 = true
      let status = false
      let msg
      if (this.number == '') {
        this.shortcuts_F4()
        status = true
        msg = '请输入卖出数量'
        // this.__TradeMessage('请输入卖出数量')
        this.yesNo2 = false
      } else {
        if (
          this.canSell == '--' ||
          Number(this.canSell) == 0 ||
          Number(this.number) > Number(this.canSell)
        ) {
          this.shortcuts_F4()
          status = true
          msg = '超出可下单最大数量'
          // this.__TradeMessage('超出可下单最大数量!')
          this.yesNo2 = false
        } else if (this.sell < 0) {
          this.shortcuts_F3()
          status = true
          msg = '请输入不小于0的卖出价！'
          // this.__TradeMessage('请输入不小于0的卖出价！')
          this.yesNo2 = false
        } else if (this.sell == '') {
          this.shortcuts_F3()
          status = true
          msg = '请输入卖出价'
          // this.__TradeMessage('请输入卖出价')
          this.yesNo2 = false
        } else if (this.number < 0) {
          this.shortcuts_F3()
          status = true
          msg = '卖出量不可小于0！'
          // this.__TradeMessage('卖出量不可小于0！')
          this.yesNo2 = false
        } else if (isNaN(this.sell)) {
          this.shortcuts_F1()
          status = true
          msg = '请输入价格'
          // this.__TradeMessage('请输入价格!')
          this.yesNo = false
        } else if (!this.isCheckHt) {
          // this.dialogVisible = true
          // 协议上需要填写相关信息
          const that = this
          this.htBsflag = 'S'
          this.htPrice = this.sell
          this.htAmount = this.number
          this.htTransactionVolume = '--'
          // this.getAnalogueMobile('S', that.data, that.sell, that.num)
          localStorage.setItem('commFormPrice', this.sell)
          localStorage.setItem('commFormNum', this.number)
          localStorage.setItem('commFormDj', this.htTransactionVolume)
          this.aggreementShow(2) // --- 新 协议
          this.agreementFlag = false
          // this.__TradeMessage('请先同意签署《订单商品销售协议》')
          this.yesNo2 = false
        } else {
          const that = this
          this.htBsflag = 'S'
          this.htPrice = this.sell
          this.htAmount = this.number
          this.htTransactionVolume = '--'
          // this.getAnalogueMobile('S', that.data, that.sell, that.number)
          // this.Ht(function() {
          protocol.param_holdTransfer.param = {
            holdId: this.getHoldId(),
            price: that.sell,
            quantity: that.number
          }
          // protocol.param_fastClose.param.price = that.sell
          // protocol.param_fastClose.param.quantity = that.number
          // protocol.param_fastClose.param.bsFlag = 'S'
          // protocol.param_fastClose.param.commodityId = that.data
          http.postFront(protocol.param_holdTransfer).then(response => {
            that.setyesNo2False()
            if (response.status == -404) {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({
                  message: '下单失败',
                  duration: 1000
                })
              }
              if (window.g.FAST_SET.FAST_fail_clear) {
                that.sell = ''
                that.number = ''
              }
              return
            }
            if (response.data && response.data.code == '0') {
              // 挂摘牌成功使用对话框提示
              if (window.g.FAST_SET.FAST_success_Dialog) {
                that.__TradeMessage({ message: response.data.message, duration: 1000 })
              }
              that.creditAvailable()
              that.shortcuts_F4()
              that.createPlayer()
              // 成功下单后 解除top随动价格显示限制
              that.emitChangeTypeUnlock()
              // 挂摘牌成功自动清除挂摘牌信息
              if (window.g.FAST_SET.FAST_success_clear) {
                that.sell = ''
                that.number = ''
              }
              // that.sell = ''
              // if (Number(that.buyLst[that.buyLst.length - 1][0]) > 0) {
              //   that.sell = Number(
              //     that.buyLst[that.buyLst.length - 1][0]
              //   ).toFixed(that.coinSmallDigital.coinDigitalNum)
              //   that.shortcuts_F4()
              // } else {
              //   that.sell = ''
              //   that.shortcuts_F3()
              // }
              // that.number = ''
            } else if (response.data.code == '-10035') {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({
                  message: '请您先进行实名认证再进行交易',
                  duration: 1000
                })
              }
              that.$router.push('/usercenter/highCertification')
            } else {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({ message: response.data.message, duration: 1000 })
              }
              if (window.g.FAST_SET.FAST_fail_clear) {
                that.sell = ''
                that.number = ''
              }
            }
          })
          // })
          // this.dialogVisible = true
          // this.agreementFlag = false
        }
      }
      if (status) {
        if (window.g.FAST_SET.FAST_fail_Dialog) {
          this.__TradeMessage(msg)
        }
        if (window.g.FAST_SET.FAST_fail_clear) {
          this.sell = ''
          this.number = ''
        }
      }
      setTimeout(() => {
        this.numSelllock = false
        this.initPrice()
      }, 0)
    },
    // 持仓Id
    getHoldId() {
      for (let i = 0; i < this.selectHoldFront.length; i++) {
        const element = this.selectHoldFront[i]
        // 卖持仓S买转让buy 买持仓B卖转让sell
        if (this.buyOrSell == 'buy' && element.bsFlag == 'S') {
          return element.holdId
        } else if (this.buyOrSell == 'sell' && element.bsFlag == 'B') {
          return element.holdId
        }
      }
      return 0
    },
    // 提示音播放
    createPlayer() {
      if (window.g.FAST_SET.FAST_Ordersuccess_Playsound) {
        const audio = new Audio(require('../../../assets/voice/1.mp3'))
        audio.play()
      }
    },
    setOrdersDialog() {
      setTimeout(() => {
        this.ordersDialog = false
      }, 100)
    },
    transBuybefore() {
      if (this.ordersDialog) {
        this.setOrdersDialog()
        return
      }
      this.transBuy()
    },
    transBuy: function() {
      this.btnFlag = 1
      // 配置是否有弹窗提示
      const showDialog = window.g.FAST_SET.FAST_show_Dialog
      if (showDialog) {
        // 陇南普通版 默认弹窗 2023 06 27
        this.$confirm('确认下单, 是否继续?', {
          customClass: 'blackMessage',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              const that = this
              instance.$refs['confirm'].$el.onclick = (function(e) {
                e = e || window.event
                if (e.detail === 0) {
                  that.ordersDialog = true
                }
              }())
            }
            done()
          }
        }).then(() => {
          this.transBuyControl()
        }).catch(() => {
        })
      } else {
        this.transBuyControl()
      }
    },
    // 查看对手方手机号
    getAnalogueMobile(bsFlag, commodityId, price, quantity) {
      protocol.param_getAnalogueMobile.param.bsFlag = bsFlag
      protocol.param_getAnalogueMobile.param.commodityId = commodityId
      protocol.param_getAnalogueMobile.param.price = price
      protocol.param_getAnalogueMobile.param.quantity = quantity
      http.postFront(protocol.param_getAnalogueMobile).then(response => {
        var { value, code } = response.data
        if (Number(code) === 0) {
          localStorage.setItem('dfName', value[0])
          this.$store.commit('setAnalogueMobileMes', value)
        }
      })
    },
    transBuyControl() {
      this.yesNo = true
      let status = false
      let msg = 1
      if (this.num == '') {
        this.shortcuts_F2()
        status = true
        msg = '请输入买入数量'
        // this.__TradeMessage('请输入买入数量')
        this.yesNo = false
      } else {
        if (
          this.canBuy == '--' ||
          Number(this.canBuy) == 0 ||
          Number(this.num) > Number(this.canBuy)
        ) {
          status = true
          msg = '超出可下单最大数量!'
          this.shortcuts_F2()
          // this.__TradeMessage('超出可下单最大数量!')
          this.yesNo = false
        } else if (this.price < 0) {
          this.shortcuts_F1()
          status = true
          msg = '请输入不小于0的买入价!'
          // this.__TradeMessage('请输入不小于0的买入价!')
          this.yesNo = false
        } else if (this.price == '') {
          this.shortcuts_F1()
          status = true
          msg = '请输入买入价!'
          // this.__TradeMessage('请输入买入价')
          this.yesNo = false
        } else if (this.num < 0) {
          this.shortcuts_F1()
          status = true
          msg = '买入量不可小于0!'
          // this.__TradeMessage('买入量不可小于0!')
          this.yesNo = false
        } else if (isNaN(this.price)) {
          this.shortcuts_F1()
          status = true
          msg = '请输入价格!'
          this.__TradeMessage('请输入价格!')
          this.yesNo = false
        } else if (!this.isCheckHt) {
          // this.dialogVisible = true

          // 协议上需要填写相关信息
          const that = this
          this.htBsflag = 'B'
          this.htPrice = this.price
          this.htAmount = this.num
          this.htTransactionVolume = '--'
          // this.getAnalogueMobile('B', that.data, that.price, that.num)
          localStorage.setItem('commFormPrice', this.price)
          localStorage.setItem('commFormNum', this.num)
          localStorage.setItem('commFormDj', this.htTransactionVolume)
          this.aggreementShow(1) // --- 新 协议
          this.agreementFlag = false
          // this.__TradeMessage('请先同意签署《订单商品销售协议》')
          this.yesNo = false
        } else {
          const that = this
          this.htBsflag = 'B'
          this.htPrice = this.price
          this.htAmount = this.num
          this.htTransactionVolume = '--'
          // this.getAnalogueMobile('B', that.data, that.price, that.num)
          // this.Ht(function() {
          // protocol.param_fastClose.param.price = that.price
          // protocol.param_fastClose.param.quantity = that.num
          // protocol.param_fastClose.param.bsFlag = 'B'
          // protocol.param_fastClose.param.commodityId = that.data
          protocol.param_holdTransfer.param = {
            holdId: this.getHoldId(),
            price: that.price,
            quantity: that.num
          }
          http.postFront(protocol.param_holdTransfer).then(response => {
            that.setyesNoFalse()
            if (response.status == -404) {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({
                  message: '下单失败',
                  duration: 1000
                })
              }
              if (window.g.FAST_SET.FAST_fail_clear) {
                that.price = ''
                that.num = ''
              }
            } else if (response.data && response.data.code == '0') {
              // 挂摘牌成功使用对话框提示
              if (window.g.FAST_SET.FAST_success_Dialog) {
                that.__TradeMessage({ message: response.data.message, duration: 1000 })
              }
              that.creditAvailable()
              that.shortcuts_F2()
              that.createPlayer()
              // 成功下单后 解除top随动价格显示限制
              that.emitChangeTypeUnlock()
              // 挂摘牌成功自动清除挂摘牌信息
              if (window.g.FAST_SET.FAST_success_clear) {
                that.price = ''
                that.num = ''
              }
              // this.price = ''
              // if (Number(that.sellLst[0][0]) > 0) {
              //   that.price = Number(that.sellLst[0][0]).toFixed(
              //     that.coinSmallDigital.coinDigitalNum
              //   )
              //   that.shortcuts_F2()
              // } else {
              //   that.price = ''
              //   that.shortcuts_F1()
              // }
              // that.num = ''
            } else if (response.data.code == '-10035') {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({
                  message: '请您先进行实名认证再进行交易',
                  duration: 1000
                })
              }
              that.$router.push('/usercenter/highCertification')
            } else {
              // 挂摘牌失败使用对话框提示
              if (window.g.FAST_SET.FAST_fail_Dialog) {
                that.__TradeMessage({ message: response.data.message, duration: 1000 })
              }
              if (window.g.FAST_SET.FAST_fail_clear) {
                that.price = ''
                that.num = ''
              }
            }
          })
          // })
          // this.dialogVisible = true
          // this.agreementFlag = false
        }
      }
      if (status) {
        if (window.g.FAST_SET.FAST_fail_Dialog) {
          this.__TradeMessage(msg)
        }
        if (window.g.FAST_SET.FAST_fail_clear) {
          this.price = ''
          this.num = ''
        }
      }
      setTimeout(() => {
        this.numBuylock = false
        this.initPrice()
      }, 0)
    },
    // 合同
    /**
     * 合同
     * bsflag 买卖方向 B S
     * type 交易类型 X:限价; S:市价
     */
    Ht(js) {
      if (this.agreementFlag) {
        this.dialogDiscoverHt = true
      }
      this.Htjs = js
    },
    // 合同通过
    htSuccess() {
      this.dialogDiscoverHt = false
      this.dialogVisible = false
      if (this.Htjs) {
        this.Htjs()
      }
    },
    // 市价交易
    market: function() {
      this.isTrue = false
      this.isTrueA = true
      this.priceTrue = true
      this.limitTrue = false
    },
    // 可用币种数据
    creditAvailable() {
      if (this.h_avilibleMargin) {
        this.balance1 = this.h_avilibleMargin
        this.balance2 = this.h_avilibleMargin
      }
    },
    // 手动刷新可用
    refreshAccount() {
      if (this.h_avilibleMargin) {
        this.balance1 = this.h_avilibleMargin
        this.balance2 = this.h_avilibleMargin
      }
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale =
        localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en':
          localStorage.setItem('isEnRealTimeTransCC', true)
          this.isEnRealTimeTransCC = localStorage.isEnRealTimeTransCC
          break
        default:
          break
      }
    },
    // 快捷键触发事件
    shortcuts_F1(event) {
      this.$refs.pricesc.focus()
    },
    shortcuts_F2(event) {
      this.$refs.numc.select()
    },
    shortcuts_F3(event) {
      this.$refs.sellpricec.focus()
    },
    shortcuts_F4(event) {
      this.$refs.sellnumc.select()
    },
    // 水平
    shortcuts_horizontal(event) {
      if (this.$refs.pricesc === document.activeElement) {
        this.shortcuts_F3()
      } else if (this.$refs.sellpricec === document.activeElement) {
        this.shortcuts_F1()
      } else if (this.$refs.numc === document.activeElement) {
        this.shortcuts_F4()
      } else if (this.$refs.sellnumc === document.activeElement) {
        this.shortcuts_F2()
      } else if (this.$refs.marketnum === document.activeElement) {
        this.shortcuts_F4()
      } else if (this.$refs.marketsellnum === document.activeElement) {
        this.shortcuts_F2()
      }
    },
    // 垂直
    shortcuts_verticality(event) {
      if (this.$refs.pricesc === document.activeElement) {
        this.shortcuts_F2()
      } else if (this.$refs.sellpricec === document.activeElement) {
        this.shortcuts_F4()
      } else if (this.$refs.numc === document.activeElement) {
        this.shortcuts_F1()
      } else if (this.$refs.sellnumc === document.activeElement) {
        this.shortcuts_F3()
      } else {
        if (this.buyOrSell == 'buy') {
          this.shortcuts_F1()
        } else {
          this.shortcuts_F3()
        }
      }
    },
    // 微调数量/价格
    shortcuts_verticality_up(event) {
      if (this.$refs.pricesc === document.activeElement) {
        if (this.price) {
          this.price = Number(this.price) + 1
        } else {
          this.price = 1
        }
      } else if (this.$refs.sellpricec === document.activeElement) {
        if (this.sell) {
          this.sell = Number(this.sell) + 1
        } else {
          this.sell = 1
        }
      } else if (this.$refs.numc === document.activeElement) {
        if (this.num) {
          this.num = Number(this.num) + 1
        } else {
          this.num = 1
        }
      } else if (this.$refs.sellnumc === document.activeElement) {
        if (this.number) {
          this.number = Number(this.number) + 1
        } else {
          this.number = 1
        }
      } else {
        if (this.buyOrSell == 'buy') {
          this.shortcuts_F1()
        } else {
          this.shortcuts_F3()
        }
      }
    },
    // 微调数量/价格
    shortcuts_verticality_down(event) {
      if (this.$refs.pricesc === document.activeElement) {
        if (this.price && this.price > 1) {
          this.price = Number(this.price) - 1
        } else {
          this.price = 1
        }
      } else if (this.$refs.sellpricec === document.activeElement) {
        if (this.sell && this.sell > 1) {
          this.sell = Number(this.sell) - 1
        } else {
          this.sell = 1
        }
      } else if (this.$refs.numc === document.activeElement) {
        if (this.num && this.num > 1) {
          this.num = Number(this.num) - 1
        } else {
          this.num = 1
        }
      } else if (this.$refs.sellnumc === document.activeElement) {
        if (this.number && this.number > 1) {
          this.number = Number(this.number) - 1
        } else {
          this.number = 1
        }
      } else {
        if (this.buyOrSell == 'buy') {
          this.shortcuts_F1()
        } else {
          this.shortcuts_F3()
        }
      }
    },
    // 订立
    shortcuts_dl() {
      this.$store.commit('dlclick')
    },
    // 转让
    shortcuts_zr() {
      this.$store.commit('zrclick')
    },
    // 切换买
    shortcuts_buy() {
      this.$store.commit('buyclick')
    },
    // 切换卖
    shortcuts_sell() {
      this.$store.commit('sellclick')
    },
    lowPriceEnter() {
      this.$refs.dialog_highPrice.focus()
    },
    // 范围撤单
    tackAndLossConfirm() {
      let isOK = true
      if (this.transfer.lowPrice == '') {
        isOK = false
        this.__TradeMessage('请输入撤单范围最低价')
      } else if (this.transfer.highPrice == '') {
        isOK = false
        this.__TradeMessage('请输入撤单范围最高价')
      } else if (Number(this.transfer.lowPrice) < 0) {
        isOK = false
        this.__TradeMessage('最低价需大于0!')
      } else if (Number(this.transfer.highPrice) < 0) {
        isOK = false
        this.__TradeMessage('最高价需大于0!')
      } else if (
        Number(this.transfer.lowPrice) > Number(this.transfer.highPrice)
      ) {
        isOK = false
        this.__TradeMessage('最低价不能大于最高价')
      }

      if (isOK) {
        this.param_rangeCancel()
      }
    },
    param_rangeCancel() {
      this.disablePC = true
      protocol.param_rangeCancel.param.highPrice = this.transfer.highPrice
      protocol.param_rangeCancel.param.lowPrice = this.transfer.lowPrice
      protocol.param_rangeCancel.param.commodityId = this.data
      http.postFront(protocol.param_rangeCancel).then(response => {
        const { code, message } = response.data
        this.dialogDiscover = false
        this.disablePC = false
        this.transfer = {
          highPrice: '',
          lowPrice: ''
        }
        this.__TradeMessage(message)
        if (code == 0) {
          // do somthing
        }
      })
    },
    // 持仓汇总查询
    queryUserPositionSummariesNew() {
      const _this = this
      if (
        !this.sessionInfoGetter.firmId ||
        this.sessionInfoGetter.firmId == '--'
      ) {
        this.selectHoldFront = this.synchronizationSummerData([])
        setTimeout(() => {
          _this.queryUserPositionSummariesNew()
        }, 1000)
        return
      }
      const queryUserPositionSummariesNew = JSON.parse(
        JSON.stringify(protocol.queryUserPositionSummariesNew)
      )
      queryUserPositionSummariesNew.data.page = 0
      queryUserPositionSummariesNew.data.bsFlag = null
      queryUserPositionSummariesNew.data.size = 3
      queryUserPositionSummariesNew.data.commodityId = this.data
      queryUserPositionSummariesNew.data.firmId = this.sessionInfoGetter.firmId

      http
        .gPost(queryUserPositionSummariesNew)
        .then(response => {
          if (response.data) {
            if (response.data && response.data.code == '0') {
              const arr = response.data.value.content
              this.selectHoldFront = this.synchronizationSummerData(arr)
            }
          }
        })
        .catch(e => {
          // setTimeout(() => {
          //   _this.queryUserPositionSummariesNew()
          // }, 1000)
        })
    },
    // 同步数据
    synchronizationSummerData(newDataArr) {
      // 对应同步vuex商品数据(买卖)
      const sysOldArr = []
      // 检查是否存在公开持仓汇总信息
      if (this.userPositionSummariesGetter.length > 0) {
        for (let i = 0; i < this.userPositionSummariesGetter.length; i++) {
          // 匹配商品信息
          if (this.userPositionSummariesGetter[i].commodityId == this.data) {
            sysOldArr.push(this.userPositionSummariesGetter[i])
          }
        }
      } else {
        return newDataArr
      }
      const returnNum = {
        Bcell: null,
        Scell: null
      }
      // 附加特殊判断,当已知列表数据为全部数据,使用全量vuex数据替换
      if (
        protocol.queryUserPositionSummariesNew.data.page == 0 &&
        !protocol.queryUserPositionSummariesNew.data.bsFlag &&
        this.userPositionSummariesGetter.length <
          Number(protocol.queryUserPositionSummariesNew.data.size)
      ) {
        return sysOldArr
      }
      // 匹配已返回新值
      for (let i = 0; i < newDataArr.length; i++) {
        if (newDataArr[i].bsFlag == 'B') {
          returnNum.Bcell = newDataArr[i]
        } else if (newDataArr[i].bsFlag == 'S') {
          returnNum.Scell = newDataArr[i]
        }
      }
      // 赋予旧值同步
      for (let i = 0; i < sysOldArr.length; i++) {
        if (sysOldArr[i].bsFlag == 'B') {
          returnNum.Bcell = sysOldArr[i]
        } else if (sysOldArr[i].bsFlag == 'S') {
          returnNum.Scell = sysOldArr[i]
        }
      }
      // 返回计算结果(匹配后)
      const returnArr = []
      if (returnNum.Bcell) {
        returnArr.push(returnNum.Bcell)
      }
      if (returnNum.Scell) {
        returnArr.push(returnNum.Scell)
      }
      return returnArr
    },
    // 替换全局message
    __TradeMessage(m) {
      this.$message.closeAll()
      this.$nextTick(() => {
        this.$message(m)
      })
    }
  }
}
</script>
<style  lang="scss">
  .el-slider__marks-stop{
    display: none !important;
  }
  .el-slider__stop{
    width: 10px !important;
    height: 10px !important;
    background: #161719;
    border-radius: 2px;
    top: -4px;
    border: 1px solid #989898;
    box-sizing: border-box;
  }
 .buyStep .el-slider__button {
  box-sizing: border-box;
  width: 10px;
  height: 10px;
  background-color: #FFFFFF;
  border: none !important;
}
.tradStep  .el-slider__button {
  box-sizing: border-box;
  width: 10px;
  height: 10px;
  background-color: #FFFFFF;
  border: none;
}
.el-slider__runway{
  height: 2px;
  margin: 4px 0;
}
.el-slider__bar{
  height: 3px;
}
.el-radio__inner{
    width: 10px;
  height: 10px;
  background-color: #989898;
  border: none;
  border-radius: 2px;
  border-radius: 0%;
  &::after{
    border-radius: 0;
  }
}
.transcc_new_NewFooter_left_top{
  display: flex;
  align-items: center;
  .transcc_new_NewFooter_left--left{
    // width: 202px;
    flex: 1;
    flex-shrink: 0;
    .el-col-21{
      margin-bottom: 16px !important;
    }
  }
}
.transcc_new_NewFooter_left_bottom{
  margin-top: 10px;
}
.el-slider__button {
  width: 12px;
  height: 12px;
}
/deep/ #btns.is-disabled {
  color: #fff !important;
  background-color: #409eff !important;
  border-color: #409eff !important;
}
/deep/ #gsHt .el-dialog {
  overflow-y: auto;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.transcc_new_NewFooter_left_top{
  display: flex;
  align-items: center;
  .transcc_new_NewFooter_left--left{
    .el-col-21{
      margin-bottom: 16px !important;
    }
  }
  .transcc_new_NewFooter_left--right{
    // width: 40px;
    .el-input__inner{
      border-color: #efefef !important;
    }
  }
}
.currentCoin {
  background-color: transparent;
  height: 110px;
  .currentRodio {
    height: 50px;
    line-height: 50px;
    padding-left: 10px;
  }
  .currentDian {
    display: inline-block;
    width: 25%;
    line-height: 50px;
    text-indent: 10px;
    /* border-bottom:1px solid #131625; */
  }
  .currentAddress {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    width: 82%;
    margin: 5px 0 5px 10px;
    border: 1px solid #1b1d24;
    text-indent: 10px;
    color: #bfc3ce;
  }
  .currentCopy {
    line-height: 40px;
    display: inline-block;
    width: 14%;
    padding-left: 18px;
    box-sizing: border-box;
    color: #bfc3ce;
  }
}
.tip .tips p {
  line-height: 30px;
}
.box {
  width: 100%;
  height: 100%;
  padding-top: 10px;
  // background-color: #131625;
  /* border-top: 35px solid #111217; */
  .maintrans {
    width: 100%;
    /* padding-left: 25px; */
    margin: 0 auto;
    box-sizing: border-box;
    .title {
      height: 35px;
      margin-bottom: 10px;
      color: #f0f1f4;
      :last-child {
        float: right;
        margin-right: -150px;
      }
      li {
        float: left;
        line-height: 35px;
        font-size: 14px;
        width: 70px;
        margin-right: 39px;
        /* text-align: center; */
      }
    }
    .content {
      width: 100%;
      height: 100%; // 与金额对齐
      border-top: none !important;
      .priceText {
        font-size: 12px;
        /* display: inline-block; */
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #EEEEEE;
      } //最大数值的限制,样式
      .priceNum {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #EEEEEE;
        /* display: inline-block; */
        /* width: 105px; */
        // overflow: hidden;
      }
      li {
        /* float:left;
        width: 50%;
        box-sizing:border-box; */
      } // 买入
      .buyStep,
      .tradStep {
        margin-top: 10px;
        margin-bottom: 34px;
        padding: 0 9px;
      }
      .left {
        display: flex;
        flex-direction: column;
        // width: 48%;
        box-sizing: border-box;
        height: 100%;
        // padding: 0 15px 0 40px;
        .hx {
          /* height: 19px;
          margin-bottom: 11px;
          font-size:16px; */
          .login,
          .register {
            font-size: 14px;
            color: white;
          }
          .word,
          .start {
            font-size: 12px;
            color: #556d89;
          }
        }
        .top {
          position: relative;
          font-size: 14px;
          width: 97%;
          height: 15px;
          margin-bottom: 20px;
          color: rgba(255, 255, 255, 0.4);
          .message {
            width: 69%;
            float: left;
          }
          .chong {
            position: absolute;
            /* top: 20px; */
            right: 0px;
            width: 35px;
            text-align: right;
            color: #99ccff;
            cursor: pointer;
            font-weight: 900;
          }
          .huazhuan {
            position: absolute;
            /* top: 20px; */
            right: 75px;
            width: 35px;
            text-align: right;
            color: #99ccff;
            cursor: pointer;
            font-weight: 900;
          }
          .chargeMoney {
            right: 0;
          }
          .fee {
            right: -20px;
            a {
              color: #99ccff;
            }
          }
        } // 买入里第二个ul
        /* .price {
          height: 20px;
          margin-bottom: 12px;
          .message {
            width: 69%;
            float: left;
          }
          .chong {
            width: 20%;
            text-align: right;
          }
        } */
        .price {
          .message {
            width: 100%;

            position: relative;
            margin-bottom: 10px;
          }
          .chong {
            /* width: 20%; */
            text-align: right;
          }
        }
        .sty {
          box-sizing: border-box;
          height: 30px;
          border: 1px solid #989898;
          border-radius: 5px;
          background-color: rgba(19, 22, 37, 0.2);
          width: 174px;
          outline-style: none;
          color: #EEEEEE;
          &:focus,&:hover{
            border: 1px solid #989898;
          }
        }
        .unit {
          position: absolute;
          display: inline-block;
          top: 216px;
          left: 45px;
        }
        .sum {
          font-size: 14px;
          width: 100%;
          // margin: 18px 0 10px 0;
          display: flex;
          justify-content: space-between;
          color: rgba(255, 255, 255, 0.4) !important;
          .message {
            // margin: 0 5px;
            display: flex;
            width: 100%;
            // margin: 0;
            justify-content: space-between;
          }
          .priceNum {
            font-size: 12px;
          }
          .chong {
            //以前是40%
            /* width: 20%; */
            display: none;
            text-align: right;
          }
        }
        .btn {
          background-color: transparent;
          border: 2px solid #989898;
          height: 28px;
          line-height: 24px;
          border-radius: 17px;
          width: 100%;
          outline-style: none;
          display: block;
          margin: 10px auto;
          font-weight: bold;
          color: #EEEEEE;
        }
        .btnA {
          background-color: #4e5985;
          height: 34px;
          border-radius: 5px;
          width: 64%;
          outline-style: none;
          margin-bottom: 10px;
          border: 0;
          display: block;
          margin: 10px auto;
          a {
            color: #fff;
          }
          span {
            color: #fff;
          }
          .login:hover,
          .register:hover {
            // color:#7D7E7F;
            color: #fff;
          }
        }
      }
    }
  }
}
.now {
  width: 20%;
  text-align: left;
  color: #f0f1f4;
}
.rate,
.rate .rate-link {
  margin: 0 !important;
  color: #99ccff;
  cursor: pointer;
}
input[type='number'] {
  text-indent: 8px;
}
/* 添加了响应式布局方式 */
@media screen and (min-width: 1600px) {
  .box .maintrans {
    // 限价交易容器
    width: 100%;
    /* margin: -40px auto 0 auto; */
    padding-left: 0 !important;
  }
  .box .maintrans .content > li {
    // 限价交易输入框
    // width: 50%;
  }
}
.mb3 {
  margin-bottom: 3px;
}
div.enRealTimeTransCC .maintrans .title > li {
  width: auto;
}
.marketSelectBox {
  font-size: 16px;
  color: #1f3f59;
  position: relative;
  margin: 11px 10px;
  border: 1px solid #1b1d24;
  height: 80px;
  .bluePoint {
    position: absolute;
    display: none;
    font-size: 40px;
    line-height: 10px;
    color: blue;
    font-weight: bolder;
    left: 10px;
    top: 13px;
  }
  .redPoint {
    position: absolute;
    display: none;
    font-size: 40px;
    line-height: 10px;
    color: red;
    font-weight: bolder;
    left: 10px;
    bottom: 18px;
  }
  .from {
    position: absolute;
    display: inline-block;
    color: darkgray;
    line-height: 40px;
    left: 30px;
    top: 0;
  }
  .to {
    position: absolute;
    display: inline-block;
    color: darkgray;
    line-height: 40px;
    left: 30px;
    top: 40px;
  }
  .BBMarket {
    position: absolute;
    display: inline-block;
    color: #bfc3ce;
    line-height: 40px;
    top: 0;
    left: 75px;
    right: 68px;
    transition: top 0.2s;
    img {
      height: 20px;
      position: absolute;
      right: 0;
      top: 10px;
    }
  }
  .ListMarket {
    position: absolute;
    display: inline-block;
    color: #bfc3ce;
    line-height: 40px;
    bottom: 0;
    left: 75px;
    transition: top 0.2s;
  }
  .rightBox {
    position: absolute;
    display: table-cell;
    top: 0;
    right: 0;
    bottom: 0;
    width: 58px;
    text-align: center;
    vertical-align: middle;
    background: rgba(111, 142, 255, 0.5);
    // border-left: 1px solid #bfc3ce;
    img {
      width: 30px;
      height: 30px;
      margin-top: 25px;
    }
  }
  .lineBox {
    position: absolute;
    display: inline-block;
    right: 58px;
    top: 39.5px;
    height: 1px;
    background: rgba(111, 142, 255, 0.5);
    left: 20px;
  }
}
.inputMessagebox input {
  background: none;
  outline: none;
  text-indent: 10px;
  width: 100%;
  font-size: 14px;
  // color: #000;
  line-height: 40px;
  border: 1px solid #ddd;
}
</style>
<style scoped lang="scss">

#exchanges .cotract{  
  color: #EEEEEE;
    .el-checkbox__input{
    .el-checkbox__inner:hover{
        border-color: #dfdfdf !important;
  }
  }
  .is-focus{
    .el-checkbox__inner{
        border-color: #dfdfdf !important;
  }
  }
  .is-checked{
     
      .el-checkbox__inner{
      background-color: #161719 !important;
      border-color: #fff !important;
    }
 
  }
}
#exchanges /deep/ .el-dialog {
  // background: rgba(38, 53, 98, 1) !important;
  height: auto !important;
}
// #exchanges /deep/  .el-dialog .el-dialog__header,#exchanges /deep/  .el-dialog .el-dialog__body,#exchanges /deep/ .el-dialog .el-dialog__footer{
//   background: rgba(38, 53, 98, 1) !important;
//   padding-top: 20px;
// }
// #exchanges /deep/  .el-dialog .el-dialog__header .el-dialog__title{
//   color: #000 !important;
// }
#exchanges /deep/ .el-button {
  background-color: #fff !important;
}
#exchanges /deep/ .el-button span {
  color: #409eff !important;
}
#exchanges /deep/ .el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: #fff !important;
}
#exchanges /deep/ .el-button--primary span {
  color: #fff !important;
}
// #exchanges /deep/ .el-dialog__headerbtn .el-dialog__close {
//     color: #000 !important;
// }
// #exchanges /deep/ .el-radio__input.is-checked .el-radio__inner {
//     border-color: gold;
//     background: gold;
// }
.ctc-bi-btns /deep/ span {
  color: #fff;
}
.ctc-bi-btns {
  float: right;
}
.box .maintrans .content .left .btn {
  text-align: center;
}
.message_right {
  width: 19%;
  float: right;
  text-align: center;
  border: 1px solid #2382fa;
  border-radius: 2px;
  color: #2382fa;
}
.protol_top {
  display: flex;
  flex-direction: column;
  .pt_title {
    margin-bottom: 2vw;
    font-size: 1vw;
  }
  .dialog_footer {
    margin-bottom: 2vw;
    display: flex;
    justify-content: flex-end;
  }
}
.protol_bottom {
  .pb_title {
    text-align: center;
    margin-bottom: 30px;
  }
}
#middleMargin,
.left {
  width: 100%;
}
.message {
  .pricebtns,.numbtns {
    width: 25px;
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .pricebtn,.numbtn {
      font-size: 12px;
      cursor: pointer;
    }
  }
}
// .flex-price-box {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// }
</style>
<style lang="scss">
#exchanges .topSelectChange {
  // height: 30px;
  // padding: 10px 0;
  box-sizing: border-box;
  .el-radio-group {
    display: felx;
    justify-content: space-between;
  }
  .el-radio {
    margin: 0 !important;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #ffffff !important;
  }
}
#exchanges .topSelectChange.buyBgc{
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #ffffff  !important;
    background: #ffffff  !important;
    &::after {
      background: #000;
      border-radius: 50%
    }
  }
}
#exchanges .topSelectChange.sellBgc{
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #ffffff !important;
    background: #ffffff !important;
    &::after {
      background: #000;
      border-radius: 50%
    }
  }
}
</style>
